import React from 'react';
import t from '../i18n/I18n';
import S3ConfigForm from './common/S3ConfigForm';
import ZoomConfigForm from './common/ZoomConfigForm';
import './S3Upload.css';
import Modal2 from '../modals/Modal2';
import PublicUrlConfig from './common/public-url-form/PublicUrlConfig';
import { RadioGroup2 } from '../common/form/RadioGroup';
import {
  S3BUCKET,
  PUBLIC_URL,
  DUPLICATE_RENAME,
  DUPLICATE_SKIP,
  DUPLICATE_ABORT,
  DUPLICATE_REPLACE
} from '../util/Constants';
import S3Action from './S3Action';
import { S3SuccessPopup, S3ErrorPopup } from './common/s3-success-popup/S3SuccessPopup';
import UploadFromUrl from '../queries/upload/UploadFromUrl';
import { Node, UploadFromUrlResponse } from '../autogenerated/ZoomBridge';
import _ from 'lodash';

const debug = require('debug')('wc:assets:S3Upload');

type Props = {
  title: string,
  onClose: Function,
  extDetails : {
    bucketName: String,
    node: Node
  }
};
type State = {
  URL_Option: string,
  isFormValid: boolean,
  s3BucketName: string,
  s3BucketPath: string,
  s3AccessId: string,
  s3AccessKey: string,
  zoomDist: string,
  region: string,
  sameNameFileOp: string,
  urls: Array<string>,
  success: boolean,
  isRequesting: boolean
};
export default class S3Upload extends React.Component<Props, State> {

  constructor(props) {
    super(props);
    this.state = {
      URL_Option: S3BUCKET,
      isFormValid: false,
      s3BucketName: this.getBucketName(),
      s3BucketPath: this.getS3BucketPath(),
      s3AccessId: '',
      s3AccessKey: '',
      zoomDist: '',
      region: '',
      sameNameFileOp: DUPLICATE_RENAME,
      urls: [''],
      success: false,
      isRequesting: false,
      isBrowseExtAsset : !_.isEmpty(this.props.extDetails)
    };
   
  }

  getBucketName = () => {
    const {extDetails} = this.props;
    if(!_.isEmpty(extDetails)) {
      return extDetails.bucketName;
    } else return '';
  }

  getS3BucketPath = () => {
    const {extDetails} = this.props;
    if(!_.isEmpty(extDetails)) {
      const path = extDetails.node.getKey();
      return path.endsWith('/') ? path.slice(0, path.length - 1) : path;
    } else return '';
  }

  error: string = null;

  componentDidMount() {
    if (this.modalRef) {
      this.bodyElement = this.modalRef._bodyNode;
      this.bodyElement.onscroll = this.onScrollHand;
    }
  }

  onScrollHand = () => {
    if (this.zoomconfigForm && this.zoomconfigForm.state.isOpenFolderSelector) {
      this.zoomconfigForm.onCloseClick();
    }
  };

  onOptionChanged = (value) => {
    this.setState({ URL_Option: value });
  };

  onBlur = (value: object) => {
    this.setState(value, this.checkFormValidity);
  };

  checkFormValidity = () => {
    const { s3BucketName, s3AccessId, s3AccessKey, zoomDist, urls, URL_Option, region } = this.state;
    if (URL_Option === S3BUCKET) {
      if (s3BucketName != '' && s3AccessId != '' && s3AccessKey != '' && region != '') {
        return true;
      }
    } else {
      if (zoomDist != '' && urls[0] != '') {
        return true;
      }
    }

    return false;
  };

  renderSelectionOptions = () => {
    const URL_Option = this.state.URL_Option;
    const radioProps = {
      value: URL_Option,
      title: t('S3_UPLOAD_TITLE'),
      name: 's3_upload_options',
      onChange: (value) => this.onOptionChanged(value),
      options: [
        { value: S3BUCKET, label: t('AMAZON_S3_BUCKET') }
        // { value: PUBLIC_URL, label: t('UPLOAD_PUBLIC_URL') }
      ]
    };
    return <RadioGroup2 {...radioProps} />;
  };

  renderS3Form = () => {
    const { s3BucketName, s3BucketPath, s3AccessId, s3AccessKey, zoomDist, sameNameFileOp,isBrowseExtAsset } = this.state;
    const s3Props = {
      s3BucketName,
      s3BucketPath,
      s3AccessId,
      s3AccessKey,
      region: '',
      isBrowseExtAsset,
      onChange: this.onBlur,
      pathToolTip: t('ZOOM_WILL_IMPORT_ALL_FILES')
    };
    const zoomConfigProps = {
      zoomDist,
      sameNameFileOp,
      onChange: this.onBlur,
      ref: (instance) => {
        this.zoomconfigForm = instance;
      }
    };
    return (
      <React.Fragment>
        <S3ConfigForm {...s3Props} />
        <ZoomConfigForm {...zoomConfigProps} />
      </React.Fragment>
    );
  };
  renderPublicUrlForm = () => {
    const { urls, zoomDist, sameNameFileOp } = this.state;
    const publicUrlProps = { urls, onChange: this.onBlur };
    const zoomConfigProps = {
      zoomDist,
      sameNameFileOp,
      onChange: this.onBlur,
      ref: (instance) => {
        this.zoomconfigForm = instance;
      }
    };
    return (
      <React.Fragment>
        <PublicUrlConfig {...publicUrlProps} />
        <ZoomConfigForm {...zoomConfigProps} />
      </React.Fragment>
    );
  };

  validateBucketPath = (value) => {
    if (!value) {
      return '';
    } else {
      return value.replace(/^\/|\/$/g, '');
    }
  };

  onSubmitClick = () => {
    if (this.state.isRequesting) {
      return;
    }
    this.setState({ isRequesting: true });
    const {
      URL_Option,
      s3BucketName,
      s3BucketPath,
      s3AccessId,
      s3AccessKey,
      zoomDist,
      sameNameFileOp,
      region = '',
      urls
    } = this.state;
    this.error = null;
    const uploadFromUrl = new UploadFromUrl();

    let onDuplicateDetect = UploadFromUrl.SKIP;
    if (sameNameFileOp == DUPLICATE_ABORT) onDuplicateDetect = UploadFromUrl.ABORT;
    else if (sameNameFileOp == DUPLICATE_REPLACE) onDuplicateDetect = UploadFromUrl.REPLACE;

    const validatedPath = this.validateBucketPath(s3BucketPath);

    if (URL_Option === S3BUCKET) {
      uploadFromUrl.addS3(s3BucketName, validatedPath, s3AccessId, s3AccessKey, onDuplicateDetect, zoomDist, region);
    } else {
      uploadFromUrl.addPath(urls, zoomDist, onDuplicateDetect);
    }

    uploadFromUrl.run().then(
      (response: UploadFromUrlResponse) => {
        this.setSuccessMsg();
        this.setState({ success: true, isRequesting: false });
      },
      (errorId: ErrorId) => {
        this.error = errorId;
        this.setSuccessMsg();
        this.setState({ success: true, isRequesting: false });
        console.log(errorId);
      }
    );
  };

  setSuccessMsg(): void {
    this.heading = this.error
      ? 'Error'
      : this.state.URL_Option === S3BUCKET
      ? t('S3_UPLOAD_SUCCESS_HEADING')
      : t('S3_UPLOAD_SUCCESS_HEADING_PUBLIC');
    this.subHeading = this.error ? this.error.errorDetails : t('S3_UPLOAD_SUCCESS_MEGGAGE');
  }

  onErrorClose = () => {
    this.error = null;
    this.setState({ success: false });
  };

  render() {
    const {isBrowseExtAsset} = this.state;
    const URL_Option = this.state.URL_Option;
    const isFormValid: boolean = this.checkFormValidity(); //this.state.isFormValid;
    const success: boolean = this.state.success;
    const isRequesting: boolean = this.state.isRequesting;
    return (
      <React.Fragment>
        {success && !this.error ? (
          <Modal2 title=" " onClose={() => this.props.onClose()}>
            <S3SuccessPopup
              img="images/green.svg"
              heading={this.heading}
              subHeading={this.subHeading}
              isS3Bucket={URL_Option === S3BUCKET}
            />
          </Modal2>
        ) : (
          <Modal2
            closeOnEsc
            closeOnOutsideClick
            name="S3UploadModal"
            title={isBrowseExtAsset ? t('INGEST_TO_ZOOM') : this.props.title}
            ref={(inst) => {
              this.modalRef = inst;
            }}
            buttons={[
              { label: t('CANCEL'), type: 'CANCEL', onClick: this.props.onClose },
              {
                label: isRequesting ? t('PLEASE_WAIT') : isBrowseExtAsset ? t('INGEST_TO_ZOOM') : t('UPLOAD_FROM_URL'),
                iconCls: isRequesting ? 'loader' : '',
                type: 'PRIMARY',
                className: isRequesting ? 'please-wait' : 'upload-button',
                disabled: !isFormValid,
                onClick: this.onSubmitClick
              }
            ]}>
            <div className="S3Upload-container">
              {/* <form> */}
              {this.renderSelectionOptions()}
              {URL_Option === S3BUCKET ? this.renderS3Form() : null}
              {URL_Option === PUBLIC_URL ? this.renderPublicUrlForm() : null}
              {/* </form> */}
            </div>
            {success && this.error ? (
              <S3ErrorPopup onClose={() => this.onErrorClose()} errorMsg={this.subHeading} />
            ) : null}
          </Modal2>
        )}
      </React.Fragment>
    );
  }
}
